export {
    default as LoadingIcon
} from "./loadingIcon";

export {
    default as NIBGATIcon
} from "./nibgatIcon";

export {
    default as NIBGATCommunityIcon
} from "./nibgatCommunityIcon";

export {
    default as CayCoreIcon
} from "./cayCoreIcon";

export {
    default as EnUsIcon
} from "./enUSIcon";

export {
    default as TRTRIcon
} from "./trTRIcon";
